
import _get from 'lodash/get';

export default {
    'MEDIA_STREAM_ID': function(screenData) {

        return _get(screenData, 'player.currentMediaItem.metaData.content_id');
    
    },
};